/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { intl } from '../../providers/IntlProvider';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import { addDocument, queryAircraftDocuments, removeDocument, updateDocument } from '../../services/api';
import { AircraftDocumentsActionTypes } from '.';

export const getDocuments =
  ({ payload }: { payload: { id: string } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await queryAircraftDocuments(payload);
    if (response) {
      dispatch({
        type: AircraftDocumentsActionTypes.SET_DOCUMENTS,
        payload: response,
      });
    }
  };
export const add =
  ({ payload }: { payload: { form: FormData } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await addDocument(payload);
    dispatch({
      type: AircraftDocumentsActionTypes.SAVE,
      payload: response,
    });
    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: intl.formatMessage({ id: 'message.onFileSuccess' }),
        type: ToastTypes.SUCCESS,
        category: ToastCategories.FLASH,
        message: '',
      },
    });
  };
export const remove =
  ({ payload }: { payload: { id: string } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    await removeDocument(payload);
    dispatch({
      type: AircraftDocumentsActionTypes.REMOVE_DOCUMENT,
      payload: {
        removeId: payload.id,
      },
    });
  };
export const update =
  ({ payload }: { payload: { id: string, form: FormData } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await updateDocument(payload);
    dispatch({
      type: AircraftDocumentsActionTypes.SAVE,
      payload: response,
    });
    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: intl.formatMessage({ id: 'message.onFileUpdate' }),
        type: ToastTypes.SUCCESS,
        category: ToastCategories.FLASH,
        message: '',
      },
    });
  };
